import Script from 'next/script';
import React from 'react';

export const FacebookScript: React.FC = () => (
  <Script
    id="facebook"
    dangerouslySetInnerHTML={{
      __html: `window.fbAsyncInit = () => {
      FB.init({
        appId: '492491817438833',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v4.0',
        cookie: true,
      });
    };

    (function (d, s, id) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'))`,
    }}
  />
);
